import { render } from "./manage_templates.html?vue&type=template&id=bddf7512&external"
import script from "./manage_templates.js?vue&type=script&lang=js&external"
export * from "./manage_templates.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__